/**
 * Api Documentation
 * Api Documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { MobileConnectWebResponse } from '../model/mobileConnectWebResponse';
import { RedirectView } from '../model/redirectView';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class MobileConnectAuthenticationService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Start authorization process
     * 
     * @param discoveryResponse Discovery response
     * @param mcc mcc
     * @param mnc mnc
     * @param msisdn msisdn
     * @param sourceIp Source IP
     * @param subscriberId Subscriber ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public mcAllowOpen(discoveryResponse?: string, mcc?: string, mnc?: string, msisdn?: string, sourceIp?: string, subscriberId?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public mcAllowOpen(discoveryResponse?: string, mcc?: string, mnc?: string, msisdn?: string, sourceIp?: string, subscriberId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public mcAllowOpen(discoveryResponse?: string, mcc?: string, mnc?: string, msisdn?: string, sourceIp?: string, subscriberId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public mcAllowOpen(discoveryResponse?: string, mcc?: string, mnc?: string, msisdn?: string, sourceIp?: string, subscriberId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {







        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (discoveryResponse !== undefined && discoveryResponse !== null) {
            queryParameters = queryParameters.set('discoveryResponse', <any>discoveryResponse);
        }
        if (mcc !== undefined && mcc !== null) {
            queryParameters = queryParameters.set('mcc', <any>mcc);
        }
        if (mnc !== undefined && mnc !== null) {
            queryParameters = queryParameters.set('mnc', <any>mnc);
        }
        if (msisdn !== undefined && msisdn !== null) {
            queryParameters = queryParameters.set('msisdn', <any>msisdn);
        }
        if (sourceIp !== undefined && sourceIp !== null) {
            queryParameters = queryParameters.set('sourceIp', <any>sourceIp);
        }
        if (subscriberId !== undefined && subscriberId !== null) {
            queryParameters = queryParameters.set('subscriberId', <any>subscriberId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<any>(`${this.basePath}/api/mc/auth/start_authorization`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Start authentication process
     * 
     * @param discoveryResponse Discovery response
     * @param mcc mcc
     * @param mnc mnc
     * @param msisdn msisdn
     * @param sourceIp Source IP
     * @param subscriberId Subscriber ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public mcAuthOpen(discoveryResponse?: string, mcc?: string, mnc?: string, msisdn?: string, sourceIp?: string, subscriberId?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public mcAuthOpen(discoveryResponse?: string, mcc?: string, mnc?: string, msisdn?: string, sourceIp?: string, subscriberId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public mcAuthOpen(discoveryResponse?: string, mcc?: string, mnc?: string, msisdn?: string, sourceIp?: string, subscriberId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public mcAuthOpen(discoveryResponse?: string, mcc?: string, mnc?: string, msisdn?: string, sourceIp?: string, subscriberId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {







        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (discoveryResponse !== undefined && discoveryResponse !== null) {
            queryParameters = queryParameters.set('discoveryResponse', <any>discoveryResponse);
        }
        if (mcc !== undefined && mcc !== null) {
            queryParameters = queryParameters.set('mcc', <any>mcc);
        }
        if (mnc !== undefined && mnc !== null) {
            queryParameters = queryParameters.set('mnc', <any>mnc);
        }
        if (msisdn !== undefined && msisdn !== null) {
            queryParameters = queryParameters.set('msisdn', <any>msisdn);
        }
        if (sourceIp !== undefined && sourceIp !== null) {
            queryParameters = queryParameters.set('sourceIp', <any>sourceIp);
        }
        if (subscriberId !== undefined && subscriberId !== null) {
            queryParameters = queryParameters.set('subscriberId', <any>subscriberId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<any>(`${this.basePath}/api/mc/auth/start_authentication`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Finish discovery process v2
     * 
     * @param description Operation description
     * @param error Any occurring error
     * @param errorDescription Longer error description if available
     * @param state Passed back state
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public mcDiscoClose2(description?: string, error?: string, errorDescription?: string, state?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public mcDiscoClose2(description?: string, error?: string, errorDescription?: string, state?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public mcDiscoClose2(description?: string, error?: string, errorDescription?: string, state?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public mcDiscoClose2(description?: string, error?: string, errorDescription?: string, state?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (description !== undefined && description !== null) {
            queryParameters = queryParameters.set('description', <any>description);
        }
        if (error !== undefined && error !== null) {
            queryParameters = queryParameters.set('error', <any>error);
        }
        if (errorDescription !== undefined && errorDescription !== null) {
            queryParameters = queryParameters.set('error_description', <any>errorDescription);
        }
        if (state !== undefined && state !== null) {
            queryParameters = queryParameters.set('state', <any>state);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<any>(`${this.basePath}/api/mc/auth/discovery_callback`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Start discovery process
     * 
     * @param ignoreIp Ignore IP
     * @param jwt Currently logged in user
     * @param mcc mcc
     * @param mnc mnc
     * @param msisdn msisdn
     * @param role Role of the connection
     * @param sourceIp Source IP
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public mcDiscoOpen(ignoreIp?: boolean, jwt?: string, mcc?: string, mnc?: string, msisdn?: string, role?: string, sourceIp?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public mcDiscoOpen(ignoreIp?: boolean, jwt?: string, mcc?: string, mnc?: string, msisdn?: string, role?: string, sourceIp?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public mcDiscoOpen(ignoreIp?: boolean, jwt?: string, mcc?: string, mnc?: string, msisdn?: string, role?: string, sourceIp?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public mcDiscoOpen(ignoreIp?: boolean, jwt?: string, mcc?: string, mnc?: string, msisdn?: string, role?: string, sourceIp?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {








        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ignoreIp !== undefined && ignoreIp !== null) {
            queryParameters = queryParameters.set('ignoreIp', <any>ignoreIp);
        }
        if (jwt !== undefined && jwt !== null) {
            queryParameters = queryParameters.set('jwt', <any>jwt);
        }
        if (mcc !== undefined && mcc !== null) {
            queryParameters = queryParameters.set('mcc', <any>mcc);
        }
        if (mnc !== undefined && mnc !== null) {
            queryParameters = queryParameters.set('mnc', <any>mnc);
        }
        if (msisdn !== undefined && msisdn !== null) {
            queryParameters = queryParameters.set('msisdn', <any>msisdn);
        }
        if (role !== undefined && role !== null) {
            queryParameters = queryParameters.set('role', <any>role);
        }
        if (sourceIp !== undefined && sourceIp !== null) {
            queryParameters = queryParameters.set('sourceIp', <any>sourceIp);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<any>(`${this.basePath}/api/mc/auth/start_discovery`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Start headless authentication process
     * 
     * @param scope To grant scopes
     * @param sdkSession SDK session
     * @param subscriberId Subscriber ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public mcHeadlessAuthOpen(scope?: string, sdkSession?: string, subscriberId?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public mcHeadlessAuthOpen(scope?: string, sdkSession?: string, subscriberId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public mcHeadlessAuthOpen(scope?: string, sdkSession?: string, subscriberId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public mcHeadlessAuthOpen(scope?: string, sdkSession?: string, subscriberId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (scope !== undefined && scope !== null) {
            queryParameters = queryParameters.set('scope', <any>scope);
        }
        if (sdkSession !== undefined && sdkSession !== null) {
            queryParameters = queryParameters.set('sdkSession', <any>sdkSession);
        }
        if (subscriberId !== undefined && subscriberId !== null) {
            queryParameters = queryParameters.set('subscriberId', <any>subscriberId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<any>(`${this.basePath}/api/mc/auth/headless_authentication`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get sector identifiers
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public mcIdentifiers(observe?: 'body', reportProgress?: boolean): Observable<Array<string>>;
    public mcIdentifiers(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<string>>>;
    public mcIdentifiers(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<string>>>;
    public mcIdentifiers(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<string>>(`${this.basePath}/api/mc/auth/sector_identifier_uri`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get sector identifiers
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public mcIdentifiers1(observe?: 'body', reportProgress?: boolean): Observable<Array<string>>;
    public mcIdentifiers1(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<string>>>;
    public mcIdentifiers1(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<string>>>;
    public mcIdentifiers1(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<string>>(`${this.basePath}/api/mc/auth/sector_identifier_uri.json`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
